
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";

import { Loader } from '../../helpers/loader';

import { supabase } from '../../api'
import { formatDateYMD, RECIPES_ORDERED_IN_LAST_MONTHS } from "../../helpers/utils";

export const Cleaning = () => {

  const [ recipes, setRecipes ] = useState()

  const [products, setProducts] = useState()
  
  const [changes, setChanges] = useState()

  const [loading, setLoading] = useState(false)


  const processData = async () => {

    const cutoffDate = new Date();
    cutoffDate.setMonth(cutoffDate.getMonth() - 120);

    
     const { data: products, error: productsErr } = await supabase
        .from('products')
        .select('*, categories (*), suppliers (*), shopProducts(*)')
        .order('last_ordered', { ascending: false })
        .not('last_ordered', 'is', null)


      const { data: recipes, error: recipesErr } = await supabase
        .from('recipes')
        .select('*, steps (*), ingredients!ingredients_parent_pid_fkey (child_pid)')
        .order('position', { foreignTable: "ingredients", ascending: true })


      setProducts(products)

      let changes = []


      const getParents = (allRecipes, recipes, level) => {

        let arr = [...recipes]
        recipes.forEach(r => {

            const parents = allRecipes.filter(r2 => r2.ingredients.find(i => i.child_pid === r.pid))

            if (parents && parents.length) {

                const recursiveParents = getParents(allRecipes, parents, level+1)
                if (recursiveParents?.length) arr = [...arr, ...recursiveParents]
                
            }
        })

        return arr 


      }

      

      recipes.forEach(r => {

        const relations = getParents(recipes, [r], 0)
        let relationsWithProduct = []

        relations && relations.length && relations.forEach(relation => {
            const product = products.find(p => p.pid === relation.pid)
            if (product) {
                relation.product = product
                relationsWithProduct.push(relation)
            }
        })

        const lastOrderedRelation = relationsWithProduct.length ? relationsWithProduct.sort((a,b) => a.product.last_ordered > b.product.last_ordered ? 1 : -1)[0] : undefined

        r.meta = {
            relations,
            relationsWithProduct,
            lastOrderedRelation 
        }

        let change = {}

        if (!!lastOrderedRelation && lastOrderedRelation?.product) {

            if (r.last_ordered === null || new Date(r.last_ordered) < new Date(lastOrderedRelation?.product?.last_ordered)) {
                change = {  pid: r.pid,  last_ordered: formatDateYMD(lastOrderedRelation?.product?.last_ordered) }
            }
        }
        
        if (change.pid) changes.push(change)


      })


      const { data: recipesChanged, error: recipesChangedErr } = await supabase
                .from('recipes')
                .upsert(
                    changes
                )



      setChanges(changes)
      setRecipes(recipes)
      setLoading(false)

      console.log('products', products)
      console.log('recipes', recipes)

      console.log('changes', changes)
    }


  if (loading) return <Loader />

  
  return (
    <div className='outer'>

        <button className='inv' onClick={processData}>START</button>

        {<><h1>Products ordered in last {RECIPES_ORDERED_IN_LAST_MONTHS} months (and future orders)</h1>

        <div style={{display:'flex', gap: 10}}>
            <div className='table-wrapper' style={{maxWidth: '50%', maxHeight: 400, overflowY: 'scroll'}}>
            <table >
            <thead className='stickyTop'>
                <tr>
                    <th>PID</th>
                    <th>NAME</th>
                    <th>LAST ORDERED</th>
                </tr>
            </thead>
            <tbody>
                {products?.map(p => {
                    
                    return <tr key={p.id}>
                        <td>{p.pid}</td>
                        <td>{p.name}</td>
                        <td>{formatDateYMD(p.last_ordered)}</td>
                        
                    </tr>
                })}

            </tbody>
            </table>
            </div>

            <div className='table-wrapper' style={{maxWidth: '50%', maxHeight: 400, overflowY: 'scroll'}}>
            <table >
            <thead className='stickyTop'>
                <tr>
                    <th>CHANGE</th>
                </tr>
            </thead>
            <tbody>
                {changes?.map(c => {
                    
                    return <tr key={c.id}>
                        <td>{JSON.stringify(c)}</td>
                        
                        
                    </tr>
                })}

            </tbody>
            </table>
            </div>
        </div>

        <br/><br/><br/><br/></>}

        <h1>Recipes</h1>

        

        <br/><br/>


        <div className='table-wrapper' >
        <table >
          <thead className='stickyTop'>
            <tr>
                <th>PID</th>
                <th>NAME</th>
                <th>RELATED RECIPES</th>
                <th>RELATED RECIPES WITH PRODUCTS</th>
                <th>LAST ORDERED RELATION</th>
                <th>LAST ORDERED PRODUCT</th>
                <th>LAST ORDERED AT</th>
            </tr>
            </thead>
            <tbody>
            {recipes?.map(r => {
                
                if (r.meta.relationsWithProduct.length === 0) return ''
                return <tr key={r.id} >
                    <td>{r.type.slice(0,1)}: {r.pid}</td>
                    <td>{r.name}</td>
                    <td>{r.meta.relations.length}</td>
                    <td>{r.meta.relationsWithProduct.length}</td>
                    <td>{r.meta.lastOrderedRelation?.name || '-'}</td>
                    <td>{r.meta.lastOrderedRelation?.product?.name || '-'}</td>
                    <td>{r.meta.lastOrderedRelation?.product?.last_ordered ? formatDateYMD(r.meta.lastOrderedRelation?.product?.last_ordered) : '-'}</td>
                </tr>
            }
            )}
            
            </tbody>    
        </table>

        <br/><br/>{recipes?.filter(r => !!r.meta.lastOrderedRelation).length} recipes with related product ordered within {RECIPES_ORDERED_IN_LAST_MONTHS} months 
        <br/><br/>{recipes?.filter(r => !r.meta.lastOrderedRelation).length} recipes no related product within {RECIPES_ORDERED_IN_LAST_MONTHS} months


        </div>
        
    </div>

  )
}

export default withRouter(Cleaning);
